module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-ab7aa00ab55b07be109f233d2766d9ba.png";